import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { isGuestContextSelector, setOnboarding } from 'modules/app/appSlice';
import useRoles from 'hooks/useRoles';

interface UseRestartOnboarding {
  restartOnboarding: () => void;
}

const useRestartOnboarding = (): UseRestartOnboarding => {
  const { isUser } = useRoles();
  const dispatch = useDispatch();
  const isGuest = useSelector(isGuestContextSelector);
  const history = useHistory();
  const location = useLocation();

  const restartOnboarding = (): void => {
    if (isUser) {
      history.push({ pathname: isGuest ? '/guest/impact' : '/impact', search: location.search });
    } else {
      history.push({ pathname: isGuest ? '/guest' : '/', search: location.search });
    }
    dispatch(setOnboarding(true));
  };

  return {
    restartOnboarding,
  };
};

export default useRestartOnboarding;
